import { useQuery } from "@tanstack/react-query";
import { fetchAccountAllowances } from "../services";
import { bigDecimal } from "js-big-decimal";
import { queryKeys } from "../lib/queryKeys";
import { QUERY_TIERS } from "../lib/queryConfig";

export const useAccountAllowances = (address: string | null) => {
  return useQuery({
    queryKey: queryKeys.accountAllowances.byAddress(address!),
    queryFn: async () => {
      if (!address) throw new Error("No address provided");

      const accountAllowances = await fetchAccountAllowances({ address });
      let allowancesSum = new bigDecimal(0);

      if (accountAllowances.allowances.length > 0) {
        const relevantAllowances = accountAllowances.allowances.filter((a) =>
          a.allowance.spend_limit.find((sl) => sl.denom === "nost")
        );

        relevantAllowances.forEach((al) => {
          const nostValues = al.allowance.spend_limit.filter((sl) => sl.denom === "nost");

          let slNostValue = new bigDecimal(0);
          if (nostValues.length > 0) {
            slNostValue = nostValues.reduce(
              (tot, d) => tot.add(new bigDecimal(d.amount)),
              new bigDecimal(0)
            );
          }

          allowancesSum = allowancesSum.add(slNostValue);
        });
      }

      return allowancesSum;
    },
    enabled: !!address,
    ...QUERY_TIERS.financial,
  });
};
